import { Authentication } from '@leedpulse-monorepo/classes';
import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { AiReceptionistTestSession } from '../../models/AiReceptionist';

interface GetCompanyAiReceptionistTestSessionPayload {
  company_id: string;
  subscription_id: string;
}

export async function getCompanyAiReceptionistTestSession(
  payload: GetCompanyAiReceptionistTestSessionPayload,
  auth: Authentication,
): Promise<AiReceptionistTestSession> {
  try {
    if (!payload.company_id || !payload.subscription_id) {
      throw new GetCompanyAiReceptionistTestSessionFailure('company_id et subscription_id sont requis');
    }

    const response = await HttpClient.post('/company/ai-receptionist/test-session', payload, auth.token);

    return response.data as AiReceptionistTestSession;
  } catch (e) {
    console.error('getCompanyAiReceptionistTestSession error:', e);
    if (e instanceof TypeError && e.message === 'Failed to fetch') {
      throw new GetCompanyAiReceptionistTestSessionFailure('Le serveur ne répond pas');
    } else if (e instanceof Error) {
      throw new GetCompanyAiReceptionistTestSessionFailure(e.message);
    }
    return Promise.reject(e);
  }
}

export class GetCompanyAiReceptionistTestSessionFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}
